export const startSlider = (sliderElement, options) => {
    if (!sliderElement || !window.Swiper) {
        return null;
    }

    return new window.Swiper(sliderElement, options);
};
